/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export enum BizCategory {
    Fashion = 'fashion',
    CosmeticsAndBeauty = 'cosmetics_and_beauty',
    HealthAndFood = 'health_and_food',
    LifeAndGrocery = 'life_and_grocery',
    Service = 'service',
    Finance = 'finance',
    Other = 'other',
}
